import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function Contact() {
	return (
		<motion.div
			className="Contact-grid"
			initial={{ opacity: 0, y: -20 }}
			whileInView={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.4, delay: 0.4 }}
			viewport={{ once: true, amount: 0.3 }}
		>
			<div className="Text-center">
				<h1 className="Main-text">Interested in doing a project together?</h1>
			</div>
			<hr className="Contact-hr" />
			<Link to={'/contact-me'} className="Contact-btn">
				<span className="Contact-btn-text">Let's talk</span>
			</Link>
		</motion.div>
	);
}

export default Contact;
